import { Vector3 } from '@babylonjs/core/Maths/math.vector';
import { Color4 } from '@babylonjs/core/Maths/math.color';
import merge from 'lodash/merge';

import { Engine } from '../../Viewer/engine';
import { ViewerLoader } from '../../Viewer/viewer';
import { HoverPoint, UiHoverPoints } from '../../Ui/uiHoverPoints';

// import { LOCAL_VIEWER_JSON } from '../../../Services/Environment/devConfig';

class ViewerDev extends ViewerLoader {
    loadStudioEngine(callback: (engine: Engine) => void) {
        callback(Engine);
    }
}
const LOCAL_VIEWER_JSON = {};
LOCAL_VIEWER_JSON.id = '6492f31e745db1df27506e99'; // Invest Bag

const container = document.getElementById('container');

const projectJson = {
    container
};

const project = merge(LOCAL_VIEWER_JSON, projectJson);

const t = new ViewerDev(project, (naker: Engine) => {
    naker.system.scene.clearColor = new Color4(0.95, 0.95, 0.95, 1);

    const cuirAgneau: HoverPoint = {
        point: new Vector3(-0.1223, 0.8138, 0.0231),
        text: 'Removable handles',
    };
    const size: HoverPoint = {
        point: new Vector3(0.1570, 0.3123, 0.1724),
        text: '20 x 17 x 8 cm',
    };
    const testUiPoint = new UiHoverPoints(naker.system, naker.sceneContainer, [cuirAgneau, size]);

    // naker.system.canvas.addEventListener('pointerdown', (e) => {
    //     const test = naker.system.pick(e);
    //     console.log(test);
    // });
});
